import { SLOTS_PER_DAY } from "@/lib/slot"
import { useCapacityPlansQuery$data } from "@/modules/productivity-cockpit/services/__generated__/useCapacityPlansQuery.graphql"

const mapSlotCapacityPlans = ({ capacityPlans }: useCapacityPlansQuery$data) =>
  Array.from(Array(SLOTS_PER_DAY).keys()).map(
    (index) => capacityPlans.find((capacityPlan) => index === capacityPlan.slotId) ?? null,
  )

export { mapSlotCapacityPlans }
